import { Tire } from 'noddi-types';
import { getDimensionsLoadSpeedString } from 'noddi-util';

interface TireBaseInfoProps {
  tire: Tire;
}

export const TireBaseInfo = ({ tire }: TireBaseInfoProps) => (
  <div className='flex flex-col'>
    <span className='font-bold'>{tire.brand.name}</span>
    <span className='font-bold'>{tire.model}</span>
    <span className='text-xs'>{getDimensionsLoadSpeedString(tire)}</span>
  </div>
);
